import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCandidateIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 36 36",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.75 14.25L18 6L14.25 14.25L6 18L14.25 21.75L18 30L21.75 21.75L30 18L21.75 14.25ZM19.485 19.485L18 22.755L16.515 19.485L13.245 18L16.515 16.515L18 13.245L19.485 16.515L22.755 18L19.485 19.485Z",
		fill: "currentColor"
	})
});
export default SvgCandidateIcon;
